import { 
  TextField, 
  Button, 
  InputAdornment, 
  CircularProgress,
  Stack,
  Box,
  FormControl,
  InputLabel,
  FilledInput,
  IconButton,
  Link,
  Typography,
  Tooltip
} from "@mui/material";
import { 
  AccountCircle, 
  Lock, 
  Login as LoginIcon,
  Visibility,
  VisibilityOff,
  HelpOutline
} from "@mui/icons-material";
import { useState } from "react";
import { INPUT_STYLES, BUTTON_STYLES } from "../constants";

/**
 * Formulario de login profesional con inputs mejorados y funcionalidades UX avanzadas
 */
export default function LoginForm({ form, loading, handleChange, handleLogin }) {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Box 
      component="form" 
      onSubmit={handleLogin}
      sx={{ width: "100%" }}
    >
      <Stack spacing={3}>
        
        {/* Input de Email/Usuario */}
        <FormControl variant="filled" fullWidth required>
          <InputLabel 
            htmlFor="email-input"
            sx={{ 
              color: "rgba(255,255,255,0.6)",
              "&.Mui-focused": {
                color: "#1976d2"
              }
            }}
          >
            Email
          </InputLabel>
          <FilledInput
            id="email-input"
            name="email"
            type="text"
            value={form.email}
            onChange={handleChange}
            disabled={loading}
            autoComplete="username"
            startAdornment={
              <InputAdornment position="start">
                <AccountCircle sx={{ color: "#64b5f6" }} />
              </InputAdornment>
            }
            sx={INPUT_STYLES}
          />
        </FormControl>

        {/* Input de Contraseña */}
        <FormControl variant="filled" fullWidth required>
          <InputLabel 
            htmlFor="password-input"
            sx={{ 
              color: "rgba(255,255,255,0.6)",
              "&.Mui-focused": {
                color: "#1976d2"
              }
            }}
          >
            Contraseña
          </InputLabel>
          <FilledInput
            id="password-input"
            name="password"
            type={showPassword ? "text" : "password"}
            value={form.password}
            onChange={handleChange}
            disabled={loading}
            autoComplete="current-password"
            startAdornment={
              <InputAdornment position="start">
                <Lock sx={{ color: "#f57c00" }} />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleTogglePassword}
                  edge="end"
                  disabled={loading}
                  sx={{
                    color: "rgba(255,255,255,0.5)",
                    "&:hover": {
                      color: "rgba(255,255,255,0.8)"
                    }
                  }}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            sx={INPUT_STYLES}
          />
        </FormControl>

        {/* Botón de Submit */}
        <Button
          fullWidth
          size="large"
          variant="contained"
          type="submit"
          disabled={loading || !form.email || !form.password}
          startIcon={loading ? null : <LoginIcon />}
          sx={{
            ...BUTTON_STYLES,
            mt: 2
          }}
        >
          {loading ? (
            <Stack direction="row" spacing={1.5} alignItems="center">
              <CircularProgress size={22} color="inherit" thickness={4} />
              <Typography variant="button">Verificando...</Typography>
            </Stack>
          ) : (
            "Iniciar sesión"
          )}
        </Button>

      </Stack>
    </Box>
  );
}

